import { ShieldCheckIcon } from "assets/icons/ShieldCheck";
import { parseDate, parseTime } from "helpers/date";
import { parsePrice, centsToDollars, isNoMaximumOOP } from "helpers/price";

import { StyledBenefitRow, StyledInsuranceContainer } from "../styled";

interface IInsuranceSection {
  name: string;
  deductible: number;
  outOfPocketMax: number;
  flatCopay: number;
  coinsurancePercent: number;
  isSecondary: boolean;
  benefitsUpdatedAt: string;
  orderCreatedDate: string;
}

function InsuranceSection({
  name,
  deductible,
  outOfPocketMax,
  flatCopay,
  coinsurancePercent,
  isSecondary,
  benefitsUpdatedAt,
  orderCreatedDate,
}: IInsuranceSection) {
  const verifiedAt = benefitsUpdatedAt || orderCreatedDate;

  return (
    <StyledInsuranceContainer className="flex flex-column p-4">
      <div className="flex align-items-start gap-2 mb-3">
        <ShieldCheckIcon
          width={22}
          height={22}
          className="purple flex-shrink-0 mt-1"
        />
        <div className="flex flex-column gap-1">
          <p className="text-lg line-height-3 font-semibold highlighted">
            {isSecondary
              ? "Your Secondary Benefit Status"
              : "Your Benefit Status"}
          </p>
          <p className="text-sm line-height-2">
            Verified {parseDate(verifiedAt, true, true)}
            {parseTime(verifiedAt, true) && ` · ${parseTime(verifiedAt, true)}`}
          </p>
        </div>
      </div>
      <StyledBenefitRow className="flex justify-content-between align-items-center gap-3 py-3">
        <p className="text-sm line-height-2">Insurance Name</p>
        <p className="text-sm line-height-2 font-semibold highlighted text-right">
          {name}
        </p>
      </StyledBenefitRow>
      <StyledBenefitRow className="flex justify-content-between align-items-center gap-3 py-3">
        <p className="text-sm line-height-2">Deductible Remaining</p>
        <p className="text-sm line-height-2 font-semibold highlighted text-right">
          {parsePrice(centsToDollars(deductible))}
        </p>
      </StyledBenefitRow>
      <StyledBenefitRow className="flex justify-content-between align-items-center gap-3 py-3">
        <p className="text-sm line-height-2">Remaining Out of Pocket</p>
        <p className="text-sm line-height-2 font-semibold highlighted text-right">
          {isNoMaximumOOP(outOfPocketMax)
            ? "No maximum"
            : parsePrice(centsToDollars(outOfPocketMax))}
        </p>
      </StyledBenefitRow>
      <StyledBenefitRow className="flex justify-content-between align-items-center gap-3 py-3">
        <p className="text-sm line-height-2">Coinsurance Rate</p>
        <p className="text-sm line-height-2 font-semibold highlighted text-right">
          {coinsurancePercent}%
        </p>
      </StyledBenefitRow>
      {flatCopay ? (
        <StyledBenefitRow className="flex justify-content-between align-items-center gap-3 py-3">
          <p className="text-sm line-height-2">Flat Copay Rate</p>
          <p className="text-sm line-height-2 font-semibold highlighted text-right">
            {parsePrice(centsToDollars(flatCopay))}
          </p>
        </StyledBenefitRow>
      ) : null}
    </StyledInsuranceContainer>
  );
}

export default InsuranceSection;
